import { localDB } from './pouchdb-config';

/**
 * Initialize database via secure API
 */
export const initializeRemoteDatabase = async () => {
  try {
    const info = await localDB.info();
    return { success: true, message: 'Database connection verified' };
  } catch (error) {
    console.error('Error initializing database:', error);
    return { success: false, error: error.message };
  }
};

export default { initializeRemoteDatabase };